<article class="alert-card" [style.--card-color]="levelMeta(alert.level).color">
  <div class="alert-card__badges">
    <span class="alert-card__badge" [style.color]="levelMeta(alert.level).color">
      {{ levelMeta(alert.level).label }}
    </span>
    <span class="alert-card__badge" [style.color]="statusMeta(alert.status).color">
      <span class="alert-card__status-dot"></span>
      {{ statusMeta(alert.status).label }}
    </span>
  </div>

  <p class="alert-card__message">{{ alert.message }}</p>

  <div class="alert-card__schedule">
    <mat-icon class="material-symbols-outlined">schedule</mat-icon>
    @if (alert.visibilityMode === 'Manual') {
      Manual — on until switched off
    } @else {
      {{ alert.showFrom | date: 'd MMM y, HH:mm' }} – {{ alert.showUntil | date: 'd MMM y, HH:mm' }}
    }
  </div>

  <div class="alert-card__last-changed">
    Last changed {{ alert.lastUpdatedAt | date: 'd MMMM y, HH:mm' }} · {{ alert.lastUpdatedBy }}
  </div>

  <div class="alert-card__footer">
    <label class="alert-toggle">
      <input
        type="checkbox"
        class="alert-toggle__input"
        [checked]="alert.isActive"
        (change)="toggleActive.emit($event)"
        [attr.aria-label]="'Toggle active: ' + alert.message" />
      <span class="alert-toggle__track"><span class="alert-toggle__thumb"></span></span>
    </label>
    <span class="alert-card__active-label">Active</span>

    <div class="alert-card__actions">
      <button matIconButton (click)="edit.emit()" matTooltip="Edit alert">
        <mat-icon class="material-symbols-outlined">edit</mat-icon>
      </button>
      <button matIconButton (click)="duplicate.emit()" matTooltip="Duplicate alert">
        <mat-icon class="material-symbols-outlined">content_copy</mat-icon>
      </button>
      <button matIconButton (click)="delete.emit()" matTooltip="Delete alert">
        <mat-icon class="material-symbols-outlined">delete</mat-icon>
      </button>
    </div>
  </div>
</article>
